import { ForgeDataType } from "interfaces/models/generateData";
import ForgeDataImporter, { ForgeDataImporterProps } from ".";
import CategoryInfoImporter from "./CategoryInfoImporter";
import FamilyInstancePositionImporter from "./FamilyInstancePositionImporter";
import SpaceImporter from "./SpaceImporter";

type ImporterOptions = ForgeDataImporterProps;

class ImportFactory {
  static createImporter(
    type: ForgeDataType,
    options: ImporterOptions
  ): ForgeDataImporter<any> {
    switch (type) {
      case ForgeDataType.CATEGORY_INFO:
        return new CategoryInfoImporter(options);

      case ForgeDataType.SPACE:
        return new SpaceImporter(options);

      case ForgeDataType.FAMILY_INSTANCE_POSITION:
        return new FamilyInstancePositionImporter(options);
      default:
        throw new Error(`Unknown exporter type: ${type}`);
    }
  }
}

export default ImportFactory;
